import { render, staticRenderFns } from "./course-list.vue?vue&type=template&id=f20fe39c&scoped=true&"
import script from "./course-list.vue?vue&type=script&lang=ts&"
export * from "./course-list.vue?vue&type=script&lang=ts&"
import style0 from "./course-list.vue?vue&type=style&index=0&id=f20fe39c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20fe39c",
  null
  
)

export default component.exports